var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "banner-user" }, [
    _c("div", { staticClass: "user-base" }, [
      _c(
        "div",
        {
          staticClass: "user-bar",
          on: {
            click: function($event) {
              return _vm.$router.push({ name: "userInfo" })
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "head-photo",
              class: "" + (_vm.userInfo.headImage ? "noBackImg" : "")
            },
            [
              _vm.userInfo.headImage
                ? _c("img", {
                    attrs: {
                      src: "" + _vm.userInfo.headImage,
                      alt: "",
                      srcset: ""
                    }
                  })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "user-text" }, [
            _c("p", [
              _vm._v(
                "Hi~ " +
                  _vm._s(
                    _vm.userInfo.account
                      ? _vm.userInfo.account
                      : _vm.userInfo.name
                  )
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("欢迎来到小黄牛供应链商城!")])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.userInfo.phone
        ? _c("div", { staticClass: "userBox" })
        : _c("div", { staticClass: "userBox" }, [
            _c("div", { staticClass: "oprationBtn" }, [
              _c(
                "span",
                {
                  staticClass: "login",
                  on: {
                    click: function() {
                      this$1.$router.push({
                        path: "/login",
                        query: { type: 2 }
                      })
                    }
                  }
                },
                [_vm._v("登录")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "register",
                  on: {
                    click: function() {
                      this$1.$router.push({
                        path: "/login",
                        query: { type: 1 }
                      })
                    }
                  }
                },
                [_vm._v("注册")]
              )
            ])
          ]),
      _vm._v(" "),
      !_vm.userInfo.name
        ? _c("div", { staticStyle: { "margin-bottom": "30px" } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buyInfo" },
        _vm._l(_vm.buyInfo, function(item) {
          return _c(
            "div",
            {
              key: item.name,
              staticClass: "buyStatus",
              on: {
                click: function($event) {
                  return _vm.goOrder(item)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "statusIcon",
                  style:
                    "\n                  background:url(" +
                    require("@/assets/images/" + item.icon + ".png") +
                    ") no-repeat center;\n                  background-size:contain;\n                "
                },
                [
                  item.num && _vm.userInfo.name
                    ? _c("span", [_vm._v(_vm._s(item.num))])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(item.name))])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "plantform-info",
        staticStyle: {
          background:
            "url(../../../../../static/image/b2c/quanyi_bg.png) no-repeat",
          "background-size": "100% 100%"
        }
      },
      [
        _c("div", { staticClass: "quanyiBox" }, [
          _c("div", { staticClass: "text1" }, [_vm._v("咖币数字权益")]),
          _vm._v(" "),
          _c("div", { staticClass: "text2" }, [
            _vm._v("致力于打造云南独特的数字权益IP")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text3" }, [
            _vm._v("积分余额："),
            _c("span", [_vm._v("0")])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2a94a663", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2a94a663","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/cereshop/pc_b2c/bannerUserInfo.vue
// module id = null
// module chunks = 